import { render } from "./baseInfoView.vue?vue&type=template&id=78d61f80&scoped=true&ts=true"
import script from "./baseInfoView.vue?vue&type=script&lang=ts"
export * from "./baseInfoView.vue?vue&type=script&lang=ts"

import "./baseInfoView.vue?vue&type=style&index=0&id=78d61f80&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78d61f80"]])

export default __exports__